import { render, staticRenderFns } from "./FavAndShare.vue?vue&type=template&id=4f18e1e2&scoped=true&"
import script from "./FavAndShare.vue?vue&type=script&lang=js&"
export * from "./FavAndShare.vue?vue&type=script&lang=js&"
import style0 from "./FavAndShare.vue?vue&type=style&index=0&id=4f18e1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18e1e2",
  null
  
)

export default component.exports